import { ChangeDetectionStrategy, Component, ViewEncapsulation, input } from '@angular/core';
import { FocusTarget } from './focus-target';

/** "Skip to main content": the first Tab stop of the shell, visible only while focused. */
@Component({
  selector: 'app-skip-link-cabinet',
  template: `<a class="skip-link" href="#main-content" (click)="skip($event)">Skip to main content</a>`,
  styleUrl: './skip-link.component.scss',
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkipLinkCabinetComponent {
  readonly target = input<FocusTarget | null>(null);

  skip(event: Event): void {
    // The hash would change the route (hash routing on desktop), so focus moves by hand.
    event.preventDefault();
    this.target()?.focus();
  }
}
